import { AuthProvider } from "./providers/auth";
import { BrowserRouter } from "react-router-dom";
import { TopLevelBoundary } from "./components/Infra/TopLevelBoundary";
import { IntercomProvider } from "react-use-intercom";
import { ToastContainer, Slide } from "react-toastify";
import { config } from "./config";
import { AppRouter } from "./providers/router";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { Stripe } from "@stripe/stripe-js";
import { PostHogProvider } from "posthog-js/react";
import { DatadogProvider } from "providers/datadog";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
const stripePromise = loadStripe(
  config.stripePublishableKey
) as unknown as PromiseLike<Stripe>;

export default function App(props: {
  token: string;
  hasClose: boolean;
  bypassPlaidAccountConfirmation: boolean;
  withIntercom?: boolean;
}) {
  return (
    <>
      <DatadogProvider />
      <PostHogProvider
        apiKey="phc_niAT2YFaNc6wNZjXbVKPh8VBue6CpXzm9r92pZmayIN"
        options={{
          api_host: "https://us.i.posthog.com"
        }}
      >
        <QueryClientProvider client={queryClient}>
          <TopLevelBoundary>
            <BrowserRouter>
              <Elements
                stripe={stripePromise}
                options={{
                  locale: "en"
                }}
              >
                <IntercomProvider appId={config.intercomId} autoBoot={false}>
                  <AuthProvider
                    token={props.token}
                    hasClose={props.hasClose}
                    bypassPlaidAccountConfirmation={
                      props.bypassPlaidAccountConfirmation
                    }
                    withIntercom={props.withIntercom}
                  >
                    <ToastContainer
                      limit={3}
                      transition={Slide}
                      className="toast-container mt-0 max-w-screen w-full m-0 p-0 !rounded-none"
                      hideProgressBar
                      closeButton={false}
                      closeOnClick
                      position="top-center"
                      autoClose={2500}
                      newestOnTop
                      theme={"colored"}
                    />
                    <AppRouter />
                  </AuthProvider>
                </IntercomProvider>
              </Elements>
            </BrowserRouter>
          </TopLevelBoundary>
        </QueryClientProvider>
      </PostHogProvider>
    </>
  );
}
